import "./App.css";

function App() {
  return (
    <main className="site-suspended">
      <section className="site-suspended__notice" aria-labelledby="site-status">
        <p className="site-suspended__label">Service notice</p>
        <h1 id="site-status">
          This service or website is no longer available. Thanks.
        </h1>
      </section>
    </main>
  );
}

export default App;
